// @noflow
import { mapKeys } from 'lodash';

const { Player: BitmovinPlayer, PlayerEvent } = process.env.IS_BROWSER
  ? require('bitmovin-player')
  : {};

const playerEventMap = PlayerEvent
  ? {
      onReady: PlayerEvent.SourceLoaded,
      onSourceLoaded: PlayerEvent.SourceLoaded,
      onSourceUnloaded: PlayerEvent.SourceUnloaded,
      onPlay: PlayerEvent.Play,
      onPaused: PlayerEvent.Paused,
      onTimeChanged: PlayerEvent.TimeChanged,
      onStallStarted: PlayerEvent.StallStarted,
      onStallEnded: PlayerEvent.StallEnded,
      onSeek: PlayerEvent.Seek,
      onSeeked: PlayerEvent.Seeked,
      onPlaybackFinished: PlayerEvent.PlaybackFinished,
    }
  : {};

export function mapPlayerEvents(events) {
  return mapKeys(events, (callback, event) => playerEventMap[event] || event);
}

export { BitmovinPlayer, PlayerEvent };
export type BitmovinPlayerT = typeof BitmovinPlayer;
